import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"education"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 8.5L12 2L22 8.5L18 11.1L12 15L6 11.1L2 8.5Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M6 17.4996V11.0996L12 14.9996L18 11.0996V17.4996C18 19.4326 15.3137 20.9996 12 20.9996C8.68629 20.9996 6 19.4326 6 17.4996Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21 9.15039V15.0004M6 11.0996V17.4996C6 19.4326 8.68629 20.9996 12 20.9996C15.3137 20.9996 18 19.4326 18 17.4996V11.0996L12 14.9996L6 11.0996ZM12 2L2 8.5L12 15L22 8.5L12 2Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Education = Vue.extend<IconProps>({
  name: 'EducationIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'education',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Education;
